<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      submitted: false,
      form: {
        id: 0,
        name: "",
        address: "",
        tin: "",
        email: "",
        contactNumber: "",
        note: "",
        owner: "",
        businessOrgType: "",
        businessType: "",
        philgeps: "",
        bank: "",
        bankAddress: "",
        accountNumber: "",
        status: "Active",
        vatType: "",
        dtiPermitNumber: "",
        mayorsPermitNumber: "",
        secLicenseNumber: "",
        pcabLicenseNumber: "",
        representative: "",
      },
      itemCategory: "",
      unit: "",
      modalTitle: "",
      clientTypes: [],
    };
  },
  validations: {
    form: {
      name: { required },
      address: { required },
      tin: { required },
      email: { required },
      contactNumber: { required },
      // vatType: { required },
      clientTypeId: { required },
      status: { required },
    },
  },
  created(){
    this.$store
      .dispatch("clienttype/GetAllClientType")
      .then((res) => {
          this.clientTypes = res.data;
      })
      .catch(() => {
          this.showToast("Something went wrong!", "error");
      });
  },
  methods: {
    onReset() {
      this.form = {
        id: 0,
        name: "",
        address: "",
        tin: "",
        email: "",
        contactNumber: "",
        note: "",
        owner: "",
        businessOrgType: "",
        businessType: "",
        philgeps: "",
        bank: "",
        bankAddress: "",
        accountNumber: "",
        status: "Active",
        vatType: "",
        dtiPermitNumber: "",
        mayorsPermitNumber: "",
        secLicenseNumber: "",
        pcabLicenseNumber: "",
        representative: "",
        clientTypeId: "",
      };
      this.unit = "";
      this.itemCategory = "";
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (this.form.id > 0) {
          this.$store
            .dispatch("supplier/UpdateSupplier", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.$emit("update-table", {data: res.data, type: 'update'})
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("supplier/CreateSupplier", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.$emit("update-table", {data: res.data, type: 'add'})
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
        this.submitted = false;
      }
    },
    updateItem(props) {
      this.form = cloneDeep(props);
      this.form.clientTypeId = this.form.clientTypeId > 0 ? this.form.clientTypeId : "";
    },
  },
};
</script>
<template>
  <b-modal
    id="supplier-form-modal"
    :title="modalTitle"
    size="xl"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="name"> Client Name </label>
            <input
              autocomplete="off"
              id="name"
              type="text"
              v-model="form.name"
              placeholder="Enter Client Name..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.name.$error,
              }"
            />
            <div
              v-if="submitted && $v.form.name.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.name.required">This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="address">Address </label>
            <textarea
              id="address"
              rows="3"
              v-model="form.address"
              placeholder="Enter Address..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.address.$error,
              }"
            ></textarea>
            <div
              v-if="submitted && $v.form.address.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.address.required"
                >This value is required.</span
              >
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="email"> Email </label>
              <input
                autocomplete="off"
                id="email"
                type="email"
                v-model="form.email"
                placeholder="Enter Email..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.form.email.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.email.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="contactNumber"> Contact Number </label>
                <input
                  autocomplete="off"
                  id="contactNumber"
                  type="contactNumber"
                  v-model="form.contactNumber"
                  placeholder="Enter Contact Number..."
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.contactNumber.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.contactNumber.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.contactNumber.required"
                    >This value is required.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tin"> VAT Type </label>
                <select class="form-select" v-model="form.vatType">
                  <option></option>
                  <option>VAT - Goods</option>
                  <option>VAT - Services</option>
                  <option>Non-VAT - Goods</option>
                  <option>Non-VAT - Services</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tin"> TIN </label>
                <input
                  autocomplete="off"
                  id="tin"
                  type="text"
                  v-model="form.tin"
                  placeholder="Enter TIN..."
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.tin.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.tin.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.tin.required"
                    >This value is required.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="owner"> Owner </label>
              <input
                autocomplete="off"
                id="owner"
                type="text"
                v-model="form.owner"
                placeholder="Enter Owner..."
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label for="bstatus"> Status </label>
              <select
                id="bstatus"
                class="form-select"
                v-model="form.status"
                placeholder="Select Status..."
                :class="{
                  'is-invalid': submitted && $v.form.status.$error,
                }"
              >
                <option></option>
                <option value="Active">Good Standing</option>
                <option value="Blocked">Block Listed</option>
                <option value="Suspended">Suspended</option>
                <option value="Inactive">Inactive</option>
              </select>
              <div
                v-if="submitted && $v.form.status.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.status.required"
                  >This value is required.</span
                >
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-md-6">
                <label for="representative">Client Type </label>
                <select
                  class="form-select"
                  v-model="form.clientTypeId"
                  :class="{
                    'is-invalid': submitted && $v.form.clientTypeId.$error,
                  }"
                >
                  <option value="0"></option>
                  <option v-for="x in clientTypes" :key="x.id" :value="x.id">
                    {{ x.name }}
                  </option>
                </select>
                <div
                  v-if="submitted && $v.form.clientTypeId.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.clientTypeId.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <label for="representative">Representative </label>
                <input
                  id="representative"
                  type="text"
                  v-model="form.representative"
                  placeholder="Enter Representative..."
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="businessType"> Business Type </label>
            <select
              autocomplete="off"
              id="businessType"
              v-model="form.businessType"
              placeholder="Select Business Type..."
              class="form-select"
            >
              <option></option>
              <option>Advertisement</option>
              <option>Air-conditioning</option>
              <option>Books</option>
              <option>Catering and Accommodation</option>
              <option>Communication</option>
              <option>Construction, Supplies and Materials</option>
              <option>Consulting Services</option>
              <option>Courier</option>
              <option>Drug and Medicines Supplies and Equipment</option>
              <option>Electrical Supplies and Materials</option>
              <option>Fire Fighting Equipment</option>
              <option>Furniture and Fixtures</option>
              <option>Garments Supplies and Materials</option>
              <option>General Merchandise</option>
              <option>Hardware Supply</option>
              <option>Information Technology and Equipment Supplies</option>
              <option>Janitorial Supplies and Equipment</option>
              <option>Laboratories, Chemical Supplies and Equipment</option>
              <option>Magazine and Journal</option>
              <option>Office Supplies, Materials & Equipment</option>
              <option>Ornaments</option>
              <option>Power Supply</option>
              <option>Printing Services</option>
              <option>Rentals</option>
              <option>Sports Supplies and Equipment</option>
              <option>Waste Disposal</option>
            </select>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="philgeps"> Philgeps </label>
              <input
                autocomplete="off"
                id="philgeps"
                type="text"
                v-model="form.philgeps"
                placeholder="Enter Philgeps..."
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label for="businessOrgType"> Organization Type </label>
              <select
                autocomplete="off"
                id="businessOrgType"
                v-model="form.businessOrgType"
                placeholder="Select Organization Type..."
                class="form-select"
              >
                <option></option>
                <option>Sole Proprietorship</option>
                <option>Partnership</option>
                <option>Corporation</option>
                <option>Limited Liability Company (LLC)</option>
              </select>
              <!-- <input
                                                    autocomplete="off"
                                                    id="businessOrgType"
                                                    type="text"
                                                    v-model="form.businessOrgType"
                                                    placeholder="Enter Organization Type..."
                                                    class="form-control"
                                                /> -->
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <label for="bank"> Bank </label>
              <input
                autocomplete="off"
                id="bank"
                type="text"
                v-model="form.bank"
                placeholder="Enter Bank..."
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label for="accountNumber"> Account Number </label>
              <input
                autocomplete="off"
                id="accountNumber"
                type="text"
                v-model="form.accountNumber"
                placeholder="Enter Account Number..."
                class="form-control"
              />
            </div>
          </div>
          <div class="mb-3">
            <label for="bankAddress"> Bank Address </label>
            <textarea
              autocomplete="off"
              id="bankAddress"
              rows="3"
              v-model="form.bankAddress"
              placeholder="Enter Bank Address..."
              class="form-control"
            ></textarea>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="dtiPermitNumber"> DTI Permit Number </label>
              <input
                autocomplete="off"
                id="dtiPermitNumber"
                type="text"
                v-model="form.dtiPermitNumber"
                placeholder="Enter DTI Permit Number..."
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label for="mayorsPermitNumber"> Mayor's Permit Number </label>
              <input
                autocomplete="off"
                id="mayorsPermitNumber"
                type="text"
                v-model="form.mayorsPermitNumber"
                placeholder="Enter Mayor's Permit Number..."
                class="form-control"
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="secLicenseNumber"> SEC Licence Number </label>
              <input
                autocomplete="off"
                id="secLicenseNumber"
                type="text"
                v-model="form.secLicenseNumber"
                placeholder="Enter SEC Licence Number..."
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label for="pcabLicenseNumber"> PCAB Licence Number </label>
              <input
                autocomplete="off"
                id="pcabLicenseNumber"
                type="text"
                v-model="form.pcabLicenseNumber"
                placeholder="Enter PCAB Licence Number..."
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="note">Note </label>
          <textarea
            id="note"
            rows="2"
            v-model="form.note"
            placeholder="Enter Note..."
            class="form-control"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Save changes</button>
        <button type="button" class="btn btn-link" @click="$bvModal.hide('supplier-form-modal')">
          Close
        </button>
      </div>
    </form>
  </b-modal>
</template>